import { render } from "./homeMentality.vue?vue&type=template&id=885ae772&scoped=true"
import script from "./homeMentality.vue?vue&type=script&lang=js"
export * from "./homeMentality.vue?vue&type=script&lang=js"

import "./homeMentality.vue?vue&type=style&index=0&id=885ae772&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885ae772"]])

export default __exports__